// 新業界レポート追加のお知らせモーダルの表示非表示
export const INDUSTRY_SECTOR_REPORT_INFO_MODAL_OPEN =
  "common/PageActions/INDUSTRY_SECTOR_REPORT_INFO_MODAL_OPEN";
export const INDUSTRY_SECTOR_REPORT_INFO_MODAL_CLOSE =
  "common/PageActions/INDUSTRY_SECTOR_REPORT_INFO_MODAL_CLOSE";
